/**
 * PageOB404.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import $ from 'jquery';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

//material-ui
import Grid from '@material-ui/core/Grid';
import PlazoFijoBoton from '../common/components/PlazoFijoBoton';
import Legales from './Legales';

//Assets
import error from '../../../static/img/404_170x108.png';
import logoBh from '../../../static/img/logo-bh.png';

import {makeRelativeRedirect,makeAbsoluteRedirect} from "../Utils/RedirectUtils"

class ErrorPlazoFijo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {
                marginTop: '',
                marginBottom: ''
            },
            disabledBtn: false,
        }
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }
    
    render() {
        const {classes} = this.props;

        let customStyles =  {
            color: '#f47321',
            backgroundColor: '#fff',
            '&hover':{
              color: '#fff',
              backgroundColor: 'white'
            }
        }

        return (
            <div className={classes.mainContainer}>
                
                <Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start">
                        <img src={logoBh} className={classes.logoBh}/>
                </Grid>

                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className={classes.containerData}>

                    <Grid item xs={12} sm={12} style={{ marginBottom: '27px' }} >
                        <img src={error} />
                    </Grid>
                    
                    <Grid item xs={12}  style={{ marginTop: '0px' }}  container direction="column" justify="center" alignItems="center">
                        <h5 className={classes.notFound} >Ups, algo falló</h5>
                        <h6 className={classes.description}>Por favor vuelve a intentarlo nuevamente en unos minutos. </h6>
                    </Grid>

                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                        <PlazoFijoBoton text="ver otros productos" doAction={ makeAbsoluteRedirect("https://www.hipotecario.com.ar/") }/>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '10px' }} container direction="row" justify="center" alignItems="center">                        
                        <PlazoFijoBoton customStyles={customStyles} text="ir al inicio" doAction={ makeRelativeRedirect(this.props.history,"/plazo-fijo") }/>
                    </Grid>

                    
                </Grid>
            </div>
        );
    }
}

const styles = theme => ({
    mainContainer : {
        marginTop: "10px",
        textAlign: "center"
    },
    logoBh: {
        float: "left",
        marginTop: "27px",
        marginLeft: "27px",
    },
    containerData:{
        marginTop : "55px"
    },
    notFound: {
        width: "258px",
        height: "30px",
        fontFamily: "Roboto",
        fontSize: "26px",
        fontWeight: "bold",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color:"#606162",
        textAlign:"center",
        marginBottom: 19,
        marginTop:0
    },
    description: {
        width: "300px",
        height: "85px",
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        textAlign: "center",
        color: "#929292",
        marginTop: 0,
        marginBottom: 10
    },
    //DESKTOP
    '@media  screen and (min-width: 787px)': {
        logoBh: {
            float: "left",
            marginTop: "42px",
            marginLeft: "263px"    
        },
        notFound: {
            width: "394px",
            height: "30px",
            marginBottom: 9
        },
        description:{
            width: "382px"
        }
    },
});

export default withStyles(styles)(ErrorPlazoFijo);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/error/ErrorPlazoFijo.js